module.exports = __webpack_public_path__ + "static/media/logo.13a1940b.png";